import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MatDialogContent } from '@angular/material/dialog';
import { ThemeService } from '../../../service/theme.service';
import { Theme } from '../../../theme/theme.interface';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatGridList, MatGridTile } from '@angular/material/grid-list';
import { MatCard, MatCardContent } from '@angular/material/card';

@Component({
    selector: 'app-theme-selector-modal',
    templateUrl: './theme-selector-modal.component.html',
    styleUrls: ['./theme-selector-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CdkScrollable, MatDialogContent, MatGridList, MatGridTile, MatCard, MatCardContent]
})
export class ThemeSelectorModalComponent implements OnInit {
  public themes: Theme[] = [];

  constructor(private themeService: ThemeService, private dialogRef: MatDialogRef<ThemeSelectorModalComponent>) { }

  public ngOnInit(): void {
    this.themes = this.themeService.getAvailableThemes();
  }

  public close(): void {
    this.dialogRef.close();
  }

  public setTheme(theme: Theme): void {
    this.themeService.setActiveTheme(theme);
  }
}
